import styled from "styled-components";
import {styledByDevice} from "../../../../themes/architecture/styled-by-device";

const CommonStyles = styled.h1`
  width: 100%;
  font-family: ${props => props.theme.font.family.secondary}; 
  color: ${props => props.theme.colors.arenaTitle};
`;

export const LobbyHeaderTitlePCBox = styled(CommonStyles)`
  padding-left: ${props => props.theme.layout.wrapper.padding.pc};
  padding-right: ${props => props.theme.layout.wrapper.padding.pc};
  font-size: 3rem;
`;

export const LobbyHeaderTitleMobileBox = styled(CommonStyles)`
  padding-left: ${props => props.theme.layout.wrapper.padding.mobile};
  padding-right: ${props => props.theme.layout.wrapper.padding.mobile};
  font-size: 2.2rem;
  display: flex;
  justify-content: space-between;
`;

export const LobbyHeaderTitleDefaultBox = styledByDevice(LobbyHeaderTitlePCBox, LobbyHeaderTitleMobileBox)